import axios from "axios"
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { getToken } from "../user/User"
import { getId, useCurrentUser, usePermissions } from "../user/User"
import md5 from "md5"
import { Autocomplete } from "@thaborach/react-autocomplete"

const Navbar = () => {
  const [client, setClient] = useState("")
  const [clients, setClients] = useState([])
  const { id, email, name } = useCurrentUser()
  const { permissions } = usePermissions(getId())

  const navigate = useNavigate()

  const logout = () => {
    sessionStorage.clear()
    localStorage.clear()
    navigate("/login")
  }

  const toggleSidebar = () => {
    const body = document.getElementsByTagName('body')[0];
    if (body) {
      if(body.classList.contains('sidebar-collapse')) {
        console.log('Close sidebar')
        body.classList.remove('sidebar-open')
        body.classList.add('sidebar-collapse')
      } else {
        console.log('Open sidebar')
        body.classList.remove('sidebar-collapse')
        body.classList.add('sidebar-open')
      }
    }
  }

  async function updateClient(newClientSearch) {
    setClient(newClientSearch)
    if(newClientSearch === "") {
        return
    }
    axios.get(process.env.REACT_APP_API_URL + "/api/clients/search/" + newClientSearch + "?limit=10", {
        headers: {
            "Authorization": "Bearer " + getToken()
        }
    }).then(res => {
      if(res.data === null || res.data === "") {
          return
      }
      setClients(res.data)
    }).catch(error => {
      console.error(error)
      if (error.response) {
            var statusCode = error.response.status
            if(statusCode === 400) {
                toast.error("Invalid request.")
                return
            }
        }
        toast.error("Internal error while updating client")
    })
  }

  async function openClient(clientId) {
    if(clientId != null && clientId != undefined) {
      navigate("/client/" + clientId)
    }
  }

  return (
    <nav className="app-header navbar navbar-expand bg-body">
      <div className="container-fluid">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-lte-toggle="sidebar" href="#" onClick={() => toggleSidebar()} role="button">
              <i className="fas fa-bars"></i>
            </a>
          </li>

          <li className="nav-item">
            <div className="nav-link">
              <div className="d-none d-sm-block col-lg-12">
                <div className="input-group" style={{marginTop: '-5px'}}>
                  <Autocomplete
                    wrapperStyle={{cursor: "pointer", float: "left"}}
                    getItemValue={(item) => item.id + ""}
                    items={clients.map(client => {
                        return client
                    })}
                    renderMenu={(items, _, style) => (items.length == 0 ? <></> :
                      <ul id="client-search" className="dropdown-menu" style={{display: "inline"}} children={items}></ul>
                    )}
                    renderItem={(client, _) =>
                      <li key={client.id}><a className="dropdown-item" href="#">{client.company_name}</a></li>
                    }
                    renderInput={(params) => (
                      <input {...params} className="form-control" placeholder="Search client" />
                    )}
                    value={client}
                    onChange={(e) => updateClient(e.target.value)}
                    onSelect={(selected) => openClient(selected)}
                  />
                  <span className="input-group-text">
                      <i className="fa-solid fa-magnifying-glass"></i>
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <ul className="navbar-nav ms-auto">
          <li className="nav-item">
            <Link to={"/settings"} className="nav-link" >
              <i className="fas fa-gear"></i>
            </Link>
          </li>
          <li className="nav-item">
            <a href="#" className="nav-link" role="button" onClick={logout}>
              <i className="fa-solid fa-right-from-bracket"></i>
            </a>
          </li>
          <li className="nav-item user-menu">
            { permissions.user !== undefined && permissions.user ?
              <Link className="nav-link" to={"/user/" + id}>
                <img src={email === null ? null : "https://www.gravatar.com/avatar/" + md5(email.toString().toLowerCase())} className="user-image rounded-circle shadow" alt="User" />
                <span className="d-none d-md-inline">{name}</span>
              </Link> :
              <a className="nav-link">
                <img src={email === null ? null : "https://www.gravatar.com/avatar/" + md5(email.toString().toLowerCase())} className="user-image rounded-circle shadow" alt="User" />
                <span className="d-none d-md-inline">{name}</span>
              </a>
            }
          </li>
        </ul>
      </div>
    </nav>
  )
}
 
export default Navbar